export default {
  getSnapshotUrl: (lectureSlug, name) => `/download/snapshot-link/${lectureSlug}/${name}`,
}
